import { render, staticRenderFns } from "./DynamicInfoReport.vue?vue&type=template&id=2562623f&scoped=true"
import script from "./DynamicInfoReport.vue?vue&type=script&lang=js"
export * from "./DynamicInfoReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2562623f",
  null
  
)

export default component.exports